class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    },300);
    setTimeout(() => {if(this.querySelector('subcart-drawer')) this.querySelector('subcart-drawer').openSubDrawer()});//cart-sub-drawer new added

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );


//     this.addEventListener(
//   'transitionend',
//   () => {
//     const containerToTrapFocusOn =
//       this.classList.contains('is-empty')
//         ? this.querySelector('.drawer__inner-empty')
//         : this.querySelector('#CartDrawer'); // scoped to this element

//     const focusElement =
//       this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');

//     if (containerToTrapFocusOn) {
//       trapFocus(containerToTrapFocusOn, focusElement);
//     }
//   },
//   { once: true }
// );






    document.body.classList.add('overflow-hidden');
  }

  close() {
    if(this.querySelector('subcart-drawer')) this.querySelector('subcart-drawer').closeSubDrawer();//cart-sub-drawer new added
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }


// renderContents(parsedState) {
//   const drawerInner = this.querySelector('.drawer__inner');
//   const cartHasItems = parsedState.items && parsedState.items.length > 0;

//   if (cartHasItems) {
//     drawerInner.classList.remove('is-empty');
//   } else {
//     drawerInner.classList.add('is-empty');
//   }

//   this.productId = parsedState.id;

//   this.getSectionsToRender().forEach((section) => {
//     if (!parsedState.sections[section.section]) return;

//     const sectionElement = section.selector
//       ? document.querySelector(section.selector)
//       : document.getElementById(section.id);

//     if (sectionElement) {
//       sectionElement.innerHTML = this.getSectionInnerHTML(
//         parsedState.sections[section.section],
//         section.selector
//       );
//     }
//   });

//   // ✅ Only open after sections updated
//   requestAnimationFrame(() => {
//     this.querySelector('#CartDrawer-Overlay')
//       .addEventListener('click', this.close.bind(this));
//     this.classList.add('animate', 'active');
//     document.body.classList.add('overflow-hidden');
//   });
// }


 



  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }


// getSectionsToRender() {
//   return [
//     {
//       id: 'CartDrawer',
//       section: 'cart-drawer',   // ✅ must match cart-drawer.liquid filename
//       selector: '#CartDrawer',
//     },
//     {
//       id: 'cart-icon-bubble',
//       section: 'cart-icon-bubble',
//     },
//   ];
//}







  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);









class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


/**** cart-sub-drawer ****/
class SubCartDrawer extends HTMLElement {
  constructor() {
    super();
    this.querySelector('.sub_drawer__close').addEventListener('click', this.closeSubDrawer.bind(this));
  }

   closeSubDrawer(){
    this.classList.remove('active')
  }

  openSubDrawer(){
    this.classList.add('animate', 'active')
  }
}

customElements.define('subcart-drawer', SubCartDrawer);







